module.exports = __webpack_public_path__ + "static/media/logo1.7adaf3b1.jpg";